import {GET_BundleNo} from '../constants/ActionTypes'

const INIT_STATE = {
    BundleId: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_BundleNo:
            return {
                BundleId: action.body,
                Ipnumber:action.ipmsg,
                loading :false
            }
        default:
            return state;
    }
}